// source: common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.common.EmailStatus', null, global);
goog.exportSymbol('proto.common.EnrichmentType', null, global);
goog.exportSymbol('proto.common.PhoneType', null, global);
goog.exportSymbol('proto.common.PrivacyScope', null, global);
goog.exportSymbol('proto.common.ProviderName', null, global);
goog.exportSymbol('proto.common.SocialMediaType', null, global);
/**
 * @enum {number}
 */
proto.common.ProviderName = {
  PROVIDER_NAME_UNKNOW: 0,
  PROVIDER_NAME_ENGINE_SEARCH: 1,
  PROVIDER_NAME_HISTORY: 2,
  PROVIDER_NAME_FAKER: 3,
  PROVIDER_NAME_APOLLO_IO: 4,
  PROVIDER_NAME_SNOV_IO: 5,
  PROVIDER_NAME_DROPCONTACT: 6,
  PROVIDER_NAME_KASPR_IO: 7,
  PROVIDER_NAME_LUSHA: 8,
  PROVIDER_NAME_PIPL: 9,
  PROVIDER_NAME_DATAGMA: 10,
  PROVIDER_NAME_EMAILLISTVERIFY: 11,
  PROVIDER_NAME_RESOLVE_DOMAIN_NAME_BY_COMPANY_NAME: 12,
  PROVIDER_NAME_PEOPLE_DATA_LABS: 13,
  PROVIDER_NAME_PROSPEO: 14,
  PROVIDER_NAME_ENROW: 15,
  PROVIDER_NAME_ICYPEAS: 16,
  PROVIDER_NAME_CONTACT_OUT: 17,
  PROVIDER_NAME_ROCKET_REACH: 18,
  PROVIDER_NAME_HUNTER: 19,
  PROVIDER_NAME_ANYMAILFINDER: 20,
  PROVIDER_NAME_SALES_NAVIGATOR: 21,
  PROVIDER_NAME_CLEON_ONE: 22,
  PROVIDER_NAME_FORAGER_IA: 23,
  PROVIDER_NAME_TWILIO: 24,
  PROVIDER_NAME_ANTHROPIC: 25,
  PROVIDER_NAME_BOUCE_BAN: 26,
  PROVIDER_NAME_LINKEDIN_PROFILE: 27,
  PROVIDER_NAME_LINKEDIN_COMPANY: 28,
  PROVIDER_NAME_ROW_VALIDATION: 29,
  PROVIDER_SEARCH_CRM: 30,
  PROVIDER_NAME_LISTMINT: 31,
  PROVIDER_NAME_FIRMABLE: 32,
  PROVIDER_NAME_WIZA: 33
};

/**
 * @enum {number}
 */
proto.common.SocialMediaType = {
  SOCIAL_MEDIA_TYPE_UNKNOW: 0,
  SOCIAL_MEDIA_TYPE_WEBSITE: 1,
  SOCIAL_MEDIA_TYPE_BLOG: 2,
  SOCIAL_MEDIA_TYPE_LINKEDIN: 3,
  SOCIAL_MEDIA_TYPE_TWITTER: 4,
  SOCIAL_MEDIA_TYPE_YOUTUBE: 5,
  SOCIAL_MEDIA_TYPE_FACEBOOK: 6,
  SOCIAL_MEDIA_TYPE_MEDIUM: 7,
  SOCIAL_MEDIA_TYPE_INSTAGRAM: 8,
  SOCIAL_MEDIA_TYPE_TIKTOK: 9,
  SOCIAL_MEDIA_TYPE_GITHUB: 10
};

/**
 * @enum {number}
 */
proto.common.PhoneType = {
  PHONE_TYPE_UNKNOW: 0,
  PHONE_TYPE_OTHER: 1,
  PHONE_TYPE_MOBILE: 2,
  PHONE_TYPE_WORK_HQ: 3
};

/**
 * @enum {number}
 */
proto.common.EmailStatus = {
  EMAIL_STATUS_UNKNOW: 0,
  EMAIL_STATUS_DELIVRABLE: 1,
  EMAIL_STATUS_INVALIDE: 2,
  EMAIL_STATUS_INVALIDE_DOMAIN: 3,
  EMAIL_STATUS_ROLE: 4,
  EMAIL_STATUS_SYNTAX: 5,
  EMAIL_STATUS_SPAM_TRAP: 6,
  EMAIL_STATUS_DISPOSABLE: 7,
  EMAIL_STATUS_CATCH_ALL: 8,
  EMAIL_STATUS_HIGHT_PROBABILITY: 9
};

/**
 * @enum {number}
 */
proto.common.EnrichmentType = {
  ENRICHMENT_TYPE_UNKNOWN: 0,
  ENRICHMENT_TYPE_FILE: 1,
  ENRICHMENT_TYPE_CONTACT: 2
};

/**
 * @enum {number}
 */
proto.common.PrivacyScope = {
  PRIVACY_SCOPE_NONE: 0,
  PRIVACY_SCOPE_INFORMATION: 1,
  PRIVACY_SCOPE_CONTACT: 2
};

goog.object.extend(exports, proto.common);
